export default __webpack_public_path__ + "locales/pt/Common.json?hash=b70e8c7ef52e1e27ac6945926b07b97d";